/**
 * Chave embutida temporariamente (repo privado) — mesma usada em produção (Static Web App).
 * REACT_APP_GOOGLE_MAPS_API_KEY em .env.local sobrescreve (útil para chave de dev).
 *
 * Se o mapa falhar só em localhost com RefererNotAllowedMapError, a chave está ok:
 * o Google Cloud bloqueia o referrer. Libere em Credentials → HTTP referrers:
 *   http://localhost:3000/*  http://localhost:3001/*
 *   http://127.0.0.1:3000/*  http://127.0.0.1:3001/*
 * Ver .env.example. Não remova os referrers de produção.
 */
const HARDCODED_GOOGLE_MAPS_API_KEY = 'AIzaSyCFuxUz7vy86obbdR62PyPmYk71_eAnkYw';

export const GOOGLE_MAPS_API_KEY =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim() || HARDCODED_GOOGLE_MAPS_API_KEY;

export function getGoogleMapsApiKey(): string {
    return GOOGLE_MAPS_API_KEY;
}

export function isGoogleMapsConfigured(): boolean {
    return GOOGLE_MAPS_API_KEY.length > 0;
}
